
const _directiveDependencies = [];

class PasswordStrengthDirective {

    constructor() {

        this.template = require('./password-strength.html');
        this.restrict = 'EA';
        this.replace = true;
        this.scope = { passlength: '=', passpattern: '=', passwordscore: '=' };

    }

}

_directiveDependencies.push(() => new PasswordStrengthDirective());

angular.module('directives')
    .directive('passwordStrength', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/auth/password-strength/password-strength.js